<!-- Compiled at 2026-09-18T12:45:23.821Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<mat-nav-list>
					<a
						mat-list-item
						routerLink="/"
						[queryParams]="{}"
						routerLinkActive="is-current-link"
						target="_self"
						[style.--mat-list-list-item-leading-icon-start-space]="(16 + 0 * 24) + 'px'"
					>
						<span matListItemIcon
							><mat-icon
								[innerHtml]="'task'"
								fontSet="material-icons"
								[inline]="false"
							></mat-icon
						></span>
						<span matListItemTitle
							><span
								[innerHtml]="'Task list' | escapeHtml: 'none' | replaceNewlines: 'span'"
							></span
						></span>
					</a>
				</mat-nav-list>

				<mat-nav-list>
					<mat-list-item
						class="has-click-handler"
						(click)="handler_NavigationItemBlock_8_click_toggleMenu_0($event, { $disabled: $disabled })"
						[style.--mat-list-list-item-leading-icon-start-space]="(16 + 0 * 24) + 'px'"
					>
						<span matListItemIcon
							><mat-icon
								[innerHtml]="'shopping_cart'"
								fontSet="material-icons"
								[inline]="false"
							></mat-icon
						></span>
						<span matListItemTitle
							><span
								[innerHtml]="'Customer requests' | escapeHtml: 'none' | replaceNewlines: 'span'"
							></span
						></span>
						<span matListItemMeta
							><mat-icon
								[innerHtml]="!screen.collapsedMenus.has('pr') ? 'expand_less' : 'expand_more'"
								fontSet="material-icons"
								[inline]="false"
							></mat-icon
						></span>
					</mat-list-item>
					<ng-container *ngIf="!screen.collapsedMenus.has('customerRequests')"
						><a
							mat-list-item
							routerLink="/CustomerRequestList"
							[queryParams]="{ filter: '#request.status!=closed' }"
							routerLinkActive="is-current-link"
							target="_self"
							[style.--mat-list-list-item-leading-icon-start-space]="(16 + 1 * 24) + 'px'"
						>
							<span matListItemIcon
								><mat-icon
									[innerHtml]="'pending'"
									fontSet="material-icons"
									[inline]="false"
								></mat-icon
							></span>
							<span matListItemTitle
								><span
									[innerHtml]="'Open ones' | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span
							></span>
						</a>

						<a
							mat-list-item
							routerLink="/CustomerRequestList"
							[queryParams]="{}"
							routerLinkActive="is-current-link"
							target="_self"
							[style.--mat-list-list-item-leading-icon-start-space]="(16 + 1 * 24) + 'px'"
						>
							<span matListItemIcon
								><mat-icon
									[innerHtml]="'search'"
									fontSet="material-icons"
									[inline]="false"
								></mat-icon
							></span>
							<span matListItemTitle
								><span
									[innerHtml]="'Search all' | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span
							></span>
						</a>
					</ng-container>

					<mat-list-item
						class="has-click-handler"
						(click)="handler_NavigationItemBlock_65_click_toggleMenu_0($event, { $disabled: $disabled })"
						[style.--mat-list-list-item-leading-icon-start-space]="(16 + 0 * 24) + 'px'"
					>
						<span matListItemIcon
							><mat-icon
								[innerHtml]="'local_shipping'"
								fontSet="material-icons"
								[inline]="false"
							></mat-icon
						></span>
						<span matListItemTitle
							><span
								[innerHtml]="'Vendor requests' | escapeHtml: 'none' | replaceNewlines: 'span'"
							></span
						></span>
						<span matListItemMeta
							><mat-icon
								[innerHtml]="!screen.collapsedMenus.has('pr') ? 'expand_less' : 'expand_more'"
								fontSet="material-icons"
								[inline]="false"
							></mat-icon
						></span>
					</mat-list-item>
					<ng-container *ngIf="!screen.collapsedMenus.has('vendorRequests')"
						><a
							mat-list-item
							routerLink="/VendorOfferList"
							[queryParams]="{ filter: '#status!=closed' }"
							routerLinkActive="is-current-link"
							target="_self"
							[style.--mat-list-list-item-leading-icon-start-space]="(16 + 1 * 24) + 'px'"
						>
							<span matListItemIcon
								><mat-icon
									[innerHtml]="'pending'"
									fontSet="material-icons"
									[inline]="false"
								></mat-icon
							></span>
							<span matListItemTitle
								><span
									[innerHtml]="'Open ones' | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span
							></span>
						</a>

						<a
							mat-list-item
							routerLink="/VendorOfferList"
							[queryParams]="{}"
							routerLinkActive="is-current-link"
							target="_self"
							[style.--mat-list-list-item-leading-icon-start-space]="(16 + 1 * 24) + 'px'"
						>
							<span matListItemIcon
								><mat-icon
									[innerHtml]="'search'"
									fontSet="material-icons"
									[inline]="false"
								></mat-icon
							></span>
							<span matListItemTitle
								><span
									[innerHtml]="'Search all' | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span
							></span>
						</a>
					</ng-container>
				</mat-nav-list>

				<mat-nav-list>
					<a
						mat-list-item
						routerLink="/MetadataManage"
						[queryParams]="{}"
						routerLinkActive="is-current-link"
						target="_self"
						[style.--mat-list-list-item-leading-icon-start-space]="(16 + 0 * 24) + 'px'"
					>
						<span matListItemIcon
							><mat-icon
								[innerHtml]="'settings'"
								fontSet="material-icons"
								[inline]="false"
							></mat-icon
						></span>
						<span matListItemTitle
							><span
								[innerHtml]="'Manage metadata' | escapeHtml: 'none' | replaceNewlines: 'span'"
							></span
						></span>
					</a>
				</mat-nav-list>

				<mat-nav-list> </mat-nav-list>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
